import { songBeat } from '~/interfaces';

/**
 * Turns cycle through the singers in order. Whose turn it is is a property of the track's changes
 * alone and exists nowhere else in the game state, so this is the single answer the score, the
 * combo, the note stats and the lyrics all read.
 */
export const getSingerAtSection = (changes: songBeat[], sectionStart: songBeat | null, singersOnTrack: number) => {
  if (singersOnTrack <= 0 || sectionStart === null) return 0;

  return changes.filter((beat) => beat <= sectionStart).length % singersOnTrack;
};
